import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { styles } from "./spinner.styles";

@customElement("bp-spinner")
export class Spinner extends LitElement {
  static styles = styles;

  @property()
  size: "xs" | "sm" | "md" | "lg" = "md";

  @property({ type: Boolean })
  invert = false;

  render() {
    return html`
      <div
        class="spinner"
        data-size="${this.size}"
        ?data-invert=${Boolean(this.invert)}
        role="status"
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-spinner": Spinner;
  }
}
